/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectCentre
 */
export interface ProjectCentre {
    /**
     * 
     * @type {string}
     * @memberof ProjectCentre
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCentre
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCentre
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCentre
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCentre
     */
    slug?: string;
}

/**
 * Check if a given object implements the ProjectCentre interface.
 */
export function instanceOfProjectCentre(value: object): value is ProjectCentre {
    return true;
}

export function ProjectCentreFromJSON(json: any): ProjectCentre {
    return ProjectCentreFromJSONTyped(json, false);
}

export function ProjectCentreFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCentre {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}

export function ProjectCentreToJSON(json: any): ProjectCentre {
    return ProjectCentreToJSONTyped(json, false);
}

export function ProjectCentreToJSONTyped(value?: ProjectCentre | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'integrationId': value['integrationId'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'slug': value['slug'],
    };
}

